<template>
  <GeneralTheme :theme="generalTheme">
    <SpeakerBio
      v-if="speakerBio"
      v-bind="speakerBio"
    />
  </GeneralTheme>
</template>

<script lang="ts" setup>
import SpeakerBio from './SpeakerBio.vue';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import type { SectionBuilderSpeakerBio } from '~/sanity/types';
defineProps<SectionBuilderSpeakerBio>();
</script>

<style></style>
